module.exports = __webpack_public_path__ + "img/icon (7).e8930f0a.png";